module.exports = require(`./${process.env.SERVER_ENV || 'staging'}`);

module.exports.isDev =
  process.env.SERVER_ENV && process.env.SERVER_ENV.includes('development');

module.exports.isProd = process.env.SERVER_ENV === 'production';

module.exports.locale = 'de';
module.exports.currency = 'EUR';
